<template>
  <div class="validate-download-page">
    <div class="main-container">
      <div class="header-container">
        <div class="header-icon"></div>
        Apphi
      </div>
      <div class="title">{{ title }}</div>
      <div class="msg">{{ msg }}</div>
      <div class="bottom-download-container">
        <div class="download-image ios" @click="iosClick"></div>
        <div class="download-image andorid" @click="androidClick"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ValidateDownloadPage",
  computed: {
    title() {
      if (this.$route.query.msg) {
        return "";
      }
      if (this.$route.query.type === "approve") {
        return "Approved";
      } else {
        return "Declined";
      }
    },
    msg() {
      if (this.$route.query.msg) {
        return this.$route.query.msg;
      }
      if (this.$route.query.type === "approve") {
        return `This schedule will auto post on @${this.$route.query.username}\nGet Apphi for free - World‘s best social media planner.`;
      } else {
        return `This schedule will not auto post on @${this.$route.query.username}\nGet Apphi for free - World‘s best social media planner.`;
      }
    },
  },
  methods: {
    iosClick() {
      window.open(
        "https://itunes.apple.com/us/app/apphi-scheduler-for-instagram/id1251406049?mt=8",
        "_blank"
      );
      this.value = false;
    },
    androidClick() {
      window.open("https://go.onelink.me/app/apphiwebforandroid", "_blank");
      this.value = false;
    },
  },
};
</script>

<style lang="less" scoped>
.validate-download-page {
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  color: white;
  .title {
    margin-top: 140px;
    text-align: center;
    font-size: 24px;
    font-weight: 500;
  }
  .msg {
    margin-top: 15px;
    text-align: center;
    white-space: pre-line;
    font-size: 14px;
    line-height: 22px;
  }
  .bottom-download-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    .download-image {
      width: 152px;
      height: 42px;
      background-size: contain;
      margin: 0 10px;
      cursor: pointer;
      &.ios {
        background-image: url("../../../public/images/common/download_ios_n2@3x.png");
        &:hover {
          background-image: url("../../../public/images/common/download_ios_s@3x.png");
        }
      }
      &.andorid {
        background-image: url("../../../public/images/common/downdoad_android_n2@3x.png");
        &:hover {
          background-image: url("../../../public/images/common/downdoad_android_s@3x.png");
        }
      }
    }
  }
  .main-container {
    width: 800px;
    .header-container {
      display: flex;
      align-items: center;
      margin-top: 15px;
      margin-left: 15px;
      font-size: 20px;
      color: white;
      .header-icon {
        width: 40px;
        height: 40px;
        margin-right: 8px;
        background-image: url("../../../public/images/login/apphilogin_icon@3x.png");
        background-size: contain;
      }
    }
  }
}
</style>
